export { default as IndexAvatar } from './IndexAvatar';



// WEBPACK FOOTER //
// ./src/components/IndexAvatar/index.ts